export default __webpack_public_path__ + "static/media/hide.54b3107d.png";